import React from 'react'
import Select from 'react-select';
const GenericDescription = () => {
    const basicDutyOpt = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className='card'>
            <div className="card-body">
                <form >
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">

                                    Generic Desc <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Accessories <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100 mt-2"
                                        id="SCAC"
                                        name="SCAC"
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Manufacturer <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="alias"
                                        name="alias"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Manufacturer Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="accountNo"
                                        name="accountNo"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Brand <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="homepageUrl"
                                        name="homepageUrl"

                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Manufacturer Address<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="trackingUrl"
                                        name="trackingUrl"

                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Model<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="bl_project"
                                        name="bl_project"

                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Country<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Country Of Origin<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    State<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="accountNo"
                                        name="accountNo"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Source Country<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Postal Code<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="accountNo"
                                        name="accountNo"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Country<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Transit Country<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit">
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit">
                            Close
                        </button>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default GenericDescription